import React from 'react';
import FundingLifecycleWorkspace from '../components/FundingLifecycleWorkspace';

export default function FundingPage() {
  return <FundingLifecycleWorkspace kind="pathway" />;
}
